{
  "slug": "highest-iq-ever-recorded",
  "title": "সর্বোচ্চ আই. কিউ. রেকর্ড করা কোনটা?",
  "description": "বিখ্যাত উচ্চতম আইকিউ দাবি, পরীক্ষার সীমা, অসঙ্গতিপূর্ণ স্কোর স্কেল এবং কেন বৈজ্ঞানিকভাবে নির্দিষ্ট বিশ্ব র‌্যাঙ্কিং নেই তা পরীক্ষা করুন।",
  "summary": "সবচেয়ে বেশি আইকিউ প্রশ্নের কোন একক যুক্তিসঙ্গত উত্তর নেই। খুব বেশি স্কোরের হিসাব করা কঠিন, পরীক্ষায় বিভিন্ন স্কেল এবং সীমা ব্যবহার করা হয়, আর অনেক বিখ্যাত দাবির প্রমাণিত প্রতিবেদন নেই।",
  "category": "IQ স্কোর ব্যাখ্যা",
  "sections": [
    {
      "heading": "কেন রেকর্ড দাবি সরাসরি তুলনা করা হয় না",
      "paragraphs": [
        "একটি IQ সংখ্যার অর্থ শুধুমাত্র একটি নামকরণকৃত বাদ্যযন্ত্র, সংস্করণ, বয়স নীতি, স্কোর ধরন এবং প্রশাসনের সাথে সম্পর্কিত। একটি স্কেল থেকে স্কোর সরাসরি অন্য একটি সংখ্যার সাথে তুলনা করা যায় না একটি যৌক্তিক রূপান্তর ছাড়া।",
        "প্রাচীন রেশিও-আইকিউ গণনা, আধুনিক বিভ্রান্তি স্কোর, শৈশবের ফলাফল, বিস্তৃত মান এবং অপর্যবেক্ষণ কুইজ প্রায়শই জনপ্রিয় তালিকায় মিশ্রিত হয় যদিও তারা বিভিন্ন পরিমাপ প্রশ্নের উত্তর দেয়।"
      ]
    },
    {
      "heading": "অতিরিক্ত স্কোরের ক্ষেত্রে অনিশ্চয়তা বেশি",
      "paragraphs": [
        "পরীক্ষায় কিছু নির্দিষ্ট সংখ্যা ও কঠিনতার পরিসীমা বিশিষ্ট বস্তু থাকে । উপরের সীমার কাছে, একটি ছোট কাঁচা স্কোরের পার্থক্য একটি বড় পার্থক্য তৈরি করতে পারে, এবং রেফারেন্স নমুনায় তুলনামূলকভাবে কম সংখ্যক পর্যবেক্ষণ থাকে ।",
        "তাই, অতিরিক্ত শেষে একটি সঠিক- দেখানো মান তার বিশ্বাসের অন্তরবর্তী এবং প্রযুক্তিগত সীমাবদ্ধতা দ্বারা ব্যাখ্যা করা উচিত। অতিরিক্ত মান সরাসরি সমর্থিত স্কোরের সমতুল্য নয়।"
      ]
    },
    {
      "heading": "কিভাবে বিখ্যাত দাবির মূল্যায়ন করা যায়",
      "paragraphs": [
        "পরীক্ষা, সংস্করণ, তারিখ, বয়স, শর্ত, নর্ম গ্রুপ এবং স্কোর নামকরণকারী একটি প্রাথমিক প্রতিবেদনের জন্য অনুসন্ধান করুন। তালিকার নিবন্ধগুলিতে যেসব উদ্ধৃতি পুনরাবৃত্তি করা হয়েছে, তার প্রমাণ পুনরাবৃত্তির মাধ্যমে যাচাই করা হয় না।",
        "সফলতা, শিক্ষা, বা কাল্পনিক আচরণকে সঠিক আইকিউ নম্বরে পরিণত করা বৈজ্ঞানিকভাবে যুক্তিসঙ্গত নয়।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ এর মান কত? 200 সম্ভব?",
      "answer": "কোন সংখ্যা কিছু ঐতিহাসিক বা বিস্তৃত স্কোরিং পদ্ধতির অধীনে দেখা যেতে পারে, কিন্তু এর অর্থ এবং সঠিকতা সম্পূর্ণরূপে যন্ত্র এবং নিয়মগুলির উপর নির্ভর করে।"
    },
    {
      "question": "আজকে কার আইকিউ সবচেয়ে বেশি?",
      "answer": "অনেক পরীক্ষা এবং স্কোর স্কেলের মধ্যে কোন ব্যাপক, তুলনামূলক, স্বাধীনভাবে যাচাইকৃত বিশ্বব্যাপী র‌্যাঙ্কিং নেই।"
    }
  ],
  "related": ["iq-160-meaning", "how-is-iq-measured", "albert-einstein-iq"],
  "sources": [
    {
      "label": "IQ - IQ শব্দের অর্থ কি?",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "পিয়ারসন - WAIS-5 নমুনা স্কোর রিপোর্ট",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
